import client from "./axiosConfig";

export const getPayroll = (params) => {
    const config = {
        url: "/payroll/salary-master/",
        method: "GET",
        params
    };
    const response = client(config);
    return response;
};

export const addPayroll = (data) => {
    const config = {
        url: "/payroll/salary-master/",
        method: "POST",
        data
    };
    const response = client(config);
    return response;
};

export const deletePayroll = (payrollId) => {
    const config = {
        url: `/payroll/salary-master/${payrollId}/`,
        method: "DELETE",
    }

    const response = client(config);
    return response;
}

export const getPayrollById = (payrollId) => {
    const config = {
        url: `/payroll/salary-master/${payrollId}/`,
        method: "GET",
    };
    const response = client(config);
    return response;
}

export const updatePayroll = (id, data) => {
    const config = {
        url: `/payroll/salary-master/${id}/`,
        method: "PATCH",
        data,
    };
    const response = client(config);
    return response;
};

export const getSalarySlips = (params) => {
    const config = {
        url: "/payroll/salary-slip/",
        method: "GET",
        params
    };
    const response = client(config);
    return response;
};

export const getSalarySlipById = (slipId) => {
    const config = {
        url: `/payroll/salary-slip/${slipId}/`,
        method: "GET",
    };
    const response = client(config);
    return response;
}

export const updateSalarySlips = (id, data) => {
    const config = {
        url: `/payroll/salary-slip/${id}/`,
        method: "PATCH",
        data,
    };
    const response = client(config);
    return response;
};

export const run_payroll = ({ month }) => {
    const config = {
        url: `/payroll/salary-slip/run-payroll/?month=${month}`,
        method: "POST",
    };
    const response = client(config);
    return response;
};

export const notifyDownloadSlips = (slip_id) => {
    const config = {
        url: `/payroll/salary-slip/${slip_id}/notify-download/`,    
        method: "POST",
    };
    const response = client(config);
    return response;
};

export const uploadSalaryExcel = (file) => {
    const formData = new FormData();
    formData.append("file", file);
    const config = {
        url: "/payroll/salary-slip/upload-excel/",
        method: "POST",
        data: formData,
        headers: {
            "Content-Type": "multipart/form-data",
        },
    };
    return client(config);
};

export const getFormB = (params) => {
    const config = {
        url: "/payroll/salary-slip/form-b/",
        method: "GET",
        params,
    };
    return client(config);
};

export const getFormD = (params) => {
    const config = {
        url: "/payroll/salary-slip/form-d/",
        method: "GET",
        params,
    };
    return client(config);
};

export const getFinancialReport = (params) => {
    const config = {
        url: "/payroll/salary-slip/financial-report/",
        method: "GET",
        params,
    };
    return client(config);
};

export const getPfEcr = (params) => {
    const config = {
        url: "/payroll/salary-slip/pf-ecr/",
        method: "GET",
        params,
    };
    return client(config);
};

export const getEsicReport = (params) => {
    const config = {
        url: "/payroll/salary-slip/esic-report/",
        method: "GET",
        params,
    };
    return client(config);
};
